export default __webpack_public_path__ + "static/media/icon_request_quote.f9b46c2b.svg";